<template>
  <div id="creditRules">
    <el-button type="primary" @click.native="addLevel">添加等级</el-button>
    <el-table
      max-height="500px"
      :data="tableData"
      style="width: 100%">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="NO"></el-table-column>
      <el-table-column prop="levelName" label="用户级别"></el-table-column>
      <el-table-column prop="type" label="信用积分区间">
        <template slot-scope="scope">
          {{scope.row.creditBootom + (scope.row.creditTop ? "~" + scope.row.creditTop : "")}}
        </template>
      </el-table-column>
      <el-table-column prop="limitNum" label="免审额度"></el-table-column>
      <el-table-column
        label="操作"
        width="120">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="editRule(scope.row)"
            type="text"
            size="small">
            编辑
          </el-button>
          <el-button
            @click.native.prevent="deleteRule(scope.row)"
            type="text"
            size="small">
            删除
          </el-button>
        </template>
      </el-table-column>

    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog
      title="用户级别设置"
      :visible.sync="dialogVisible"
      @close="closeCreditsLevelDialog"
      width="30%">
      <el-form ref="addForm" :model="addForm" :rules="rules" label-width="150px">
        <el-form-item label="用户等级名称" prop="levelName">
          <el-input v-model.trim="addForm.levelName" placeholder="用户等级名称,1-4个字"></el-input>
        </el-form-item>
        <el-form-item label="累计积分最低指标" prop="creditBootom">
          <el-input v-model="addForm.creditBootom" type="number" placeholder="最低积分"></el-input>
        </el-form-item>
        <el-form-item label="累计积分最高指标">
          <el-input v-model="addForm.creditTop" type="number" placeholder="最高积分，不填则无上限"></el-input>
        </el-form-item>
        <el-form-item label="免审信用额度" prop="limitNum">
          <el-input v-model="addForm.limitNum" type="number" placeholder="用户每日自动审批额度"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeCreditsLevelDialog">取 消</el-button>
        <el-button type="primary" @click="changeCreditLevelsSure">{{action == "add" ? "保存" : "修改"}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import utils from "../utils/utils"
  export default {
    name: "credit-level",
    data(){
      return{
        tableData:[],
        pageInfo:{
          currentPage:1,
          pageSize:20,
          total:0
        },
        dialogVisible:false,
        creditsValue:null,
        levelId:null,
        addForm:{
          levelName:"",
          creditBootom:null,
          creditTop:null,
          limitNum:null
        },
        action:"",
        rules:{
          levelName: [
            { required: true, message: '用户等级名称不能为空', trigger: 'blur' },
            { min: 1, max: 4, message: '长度在 1 到 4 个字符', trigger: 'blur' }
          ],
          creditBootom:[
            { required: true, message: '累计积分最低指标不能为空', trigger: 'blur' }
          ],
          limitNum:[
            { required: true, message: '免审信用额度不能为空', trigger: 'blur' }
          ],
        }

      }
    },
    created(){
      this.getData()
    },
    methods:{
      //获取数据
      getData(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        let success = (response) => {
          loading.close();
          if(response.data.code === 0){
            this.tableData = response.data.list
            this.pageInfo.total = response.data.total;
          }
        }
        utils.axiosMethods({
          method:"POST",
          url:"/api/creditManage/queryLevel",
          params:{
            currentPage:this.pageInfo.currentPage,
            pageSize:this.pageInfo.pageSize
          },
          data:{

          },
          callback:success,
          catch:(err => {
            loading.close()
          })
        })
      },
      //添加等级
      addLevel(){
        this.dialogVisible = true;
        this.action = "add";
      },
      //编辑规则
      editRule(row){
        this.dialogVisible = true;
        this.levelId = row.id;
        this.action = "edit";
        this.addForm = row;
      },
      //每页展示数据条数改变
      handleSizeChange(val){
        this.pageInfo.pageSize = val;
        this.getData();
      },
      //页码改变
      handleCurrentChange(val){
        this.pageInfo.currentPage = val;
        this.getData();
      },
      //关闭积分额度设置
      closeCreditsLevelDialog(){
        this.dialogVisible = false;
        this.levelId = null;
        this.addForm = {
          levelName:"",
          creditBootom:null,
          creditTop:null,
          limitNum:null
        }
      },
      //  确认修改积分额度
      changeCreditLevelsSure(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        let url,data;
        if(this.action == "add"){
          url = "/api/creditManage/insertLevel"
          data = {
            levelName:this.addForm.levelName,
            creditBootom:this.addForm.creditBootom,
            creditTop:this.addForm.creditTop,
            limitNum:this.addForm.limitNum
          }
        }else{
          url = "/api/creditManage/updateLevel"
          data = {
            id:this.levelId,
            levelName:this.addForm.levelName,
            creditBootom:this.addForm.creditBootom,
            creditTop:this.addForm.creditTop,
            limitNum:this.addForm.limitNum
          }
        }
        utils.axiosMethods({
          method:"POST",
          url:url,
          data:data,
          callback:(res => {
            loading.close();
            if(res.data.code == 0){
              this.$message({
                message: this.action == "add"?'恭喜你，添加成功':'恭喜你，修改成功',
                type: 'success'
              });
              this.closeCreditsLevelDialog();
              this.getData();
            }else{
              this.$message.error(res.data.msg);
            }
          }),
          catch:(err =>{
            loading.close()
          })
        })
      },
      deleteRule(row){
        utils.axiosMethods({
          method:"POST",
          url:"/api/creditManage/deleteLevelById",
          params:{
            id:row.id
          },
          callback:(res => {
            this.$message({
              message: '恭喜你，删除成功',
              type: 'success'
            });
            this.getData();
          })
        })
      }
    }
  }
</script>

<style scoped lang="less">
  #creditRules{
    .block{
      float: right;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/creditLevel.vue